// extracted by mini-css-extract-plugin
module.exports = {"SStarSvg":"StarSvg_SStarSvg__I15m9","SFilledPath":"StarSvg_SFilledPath__yXrgw","isFilled":"StarSvg_isFilled__U1_xk"};